import { put, select, takeLatest, delay } from 'redux-saga/effects'
import { PatientDemographicsConstants } from '../store/patientDemographics.constants'
import { IPatientDemographicsState } from '../store/patientDemographics.types'
import { getPatientDemographicsSelector } from '../selectors'
import {
  getAgeFromReference,
  getAgeUnitOptionIdFromReference,
  isValidNemsisDOB,
} from '../../../utilities/dateTime.util'
import { savePatientDemographics, setAge, setAgePNNV, setAgeUnit } from '../store/patientDemographics.actions'
import { getPatientDemographicsOptionsSelector } from '../../options/selectors'
import { getTimesSelector } from '../../times/selectors'
import { TimesConstants } from '../../times/store/times.constants'
import ValidationService from '../../validation/services/validation.services'

export function* setPatientAge(action: { type: string }) {
  const { dOB, agePNNV }: IPatientDemographicsState = yield select(getPatientDemographicsSelector)
  const { ageUnitOptions } = yield select(getPatientDemographicsOptionsSelector)
  const { dispatchedDate } = yield select(getTimesSelector)

  if (agePNNV && !(dOB && isValidNemsisDOB(dOB))) {
    return
  }

  if (dOB && isValidNemsisDOB(dOB)) {
    const referenceDate = dispatchedDate || null
    yield put(setAge(getAgeFromReference(dOB, referenceDate)))
    yield put(setAgePNNV(null))
    const id = getAgeUnitOptionIdFromReference(dOB, referenceDate)
    const ageUnitOption = ageUnitOptions.filter((option: { id: any }) => String(option.id) === id)
    yield put(setAgeUnit(ageUnitOption ? ageUnitOption[0] : null))
    yield delay(500)
    yield put(savePatientDemographics())
  } else if (!dOB && action.type === PatientDemographicsConstants.SET_DOB) {
    yield put(setAge(null))
    yield put(setAgeUnit(null))
    ValidationService.clearValidation(PatientDemographicsConstants.SET_AGE)
    yield delay(500)
    yield put(savePatientDemographics())
  }
}
export function* setPatientAgeSaga() {
  yield takeLatest([PatientDemographicsConstants.SET_DOB, TimesConstants.SET_DISPATCHED_DATE], setPatientAge)
}
